import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location._id',
  })

  return useMemo(() => {
    if (!data) return data
    if (data.companies[0]?.status !== 'granted') return null

    return {
      ...data,
      company: data.companies[0],
      connections: data.connections.map(connection => ({
        ...connection,
        current_location_resource: connection?.resources.find(
          x => x.resource_id === location_id
        ),
      })),
    }
  }, [data, location_id])
}
